import FeedItems from './FeedItems';

export default FeedItems;
